module.exports = __webpack_public_path__ + "img/firework.59196ee8.svg";